import script from "./SuspectNoticeSp.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspectNoticeSp.vue?vue&type=script&setup=true&lang=js"

import "./SuspectNoticeSp.vue?vue&type=style&index=0&id=1ebdde50&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebdde50"]])

export default __exports__